import querystring from 'querystring';

export const searchToObj = (search: string): { [key: string]: string } =>
  querystring.parse(search.slice(1)) as { [key: string]: string };
